import { IconProps } from "./Icon.model";

export function BookmarkIcon({ size = 13, fill = "currentColor" }: IconProps) {
  const fillColor =
    fill === "currentColor" ? "var(--slate-11)" : `var(--${fill}-8)`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={(size * 15) / 13}
      viewBox="0 0 13 15"
      fill="none"
    >
      <path
        d="M6.54199 0C7.92047 -1.26896e-05 9.01153 0.000453472 9.86523 0.12793C10.7478 0.259774 11.4484 0.536432 11.9932 1.1416C12.5311 1.73934 12.7713 2.49502 12.8867 3.44922C13.0002 4.38689 13 5.59009 13 7.13184C13 8.67373 13.0002 9.94704 12.8867 10.8848C12.7713 11.8387 12.5309 12.5937 11.9932 13.1914C11.4484 13.7967 10.7479 14.0742 9.86523 14.2061C9.01154 14.3335 7.92045 14.334 6.54199 14.334H6.45801C5.07955 14.334 3.98846 14.3335 3.13477 14.2061C2.2521 14.0742 1.55159 13.7967 1.00684 13.1914C0.469086 12.5937 0.228733 11.8387 0.113281 10.8848C-0.000185808 9.94704 -6.22047e-06 8.67373 0 7.13184C-6.3783e-06 5.59009 -0.000178229 4.38689 0.113281 3.44922C0.228746 2.49502 0.468874 1.73934 1.00684 1.1416C1.55157 0.536432 2.25218 0.259774 3.13477 0.12793C3.98847 0.000453307 5.07953 -1.25307e-05 6.45801 0H6.54199ZM6.5 1.14062C5.64068 1.14062 4.9303 1.1416 4.33301 1.16699V5.71777C4.33301 6.14967 4.35096 6.46762 4.37695 6.65039C4.47501 6.61812 4.60642 6.54638 4.76855 6.43555C5.12092 6.15842 5.87066 5.58723 6.05078 5.5166C6.17273 5.45446 6.32092 5.39941 6.5 5.39941C6.67908 5.39941 6.82727 5.45446 6.94922 5.5166C7.12372 5.58573 7.87674 6.15779 8.23145 6.43555C8.39371 6.54646 8.53277 6.62011 8.63086 6.65234C8.65681 6.46952 8.66699 6.14939 8.66699 5.71777V1.16699C8.0697 1.1416 7.35932 1.14062 6.5 1.14062Z"
        fill={fillColor}
      />
    </svg>
  );
}

